<template>
    <div class="transaction-list-card">
        <el-table
            :data="operations"
            :empty-text="translate('messages.view.no_data')"
            highlight-current-row
        >
            <el-table-column
                min-width="90px"
                prop="operation"
                :label="translate('table.operation')"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="transaction-list_text">
                        {{ translate('messages.operations.' + scope.row.codigoTipoTransacao.toLowerCase()) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="130px"
                prop="codigoProduto"
                :label="translate('table.product')"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="transaction-list_text">
                        {{ translate(`table.product_codes.${scope.row.codigoProduto.toLowerCase()}`) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="138px"
                prop="dataTransacao"
                :label="translate('table.operation_date')"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <div>
                        {{ formatDateTimeToString(scope.row.dataTransacao )[0] }}
                    </div>
                    <div class="table_second-row-label">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ formatDateTimeToString(scope.row.dataTransacao )[1] }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="200px"
                prop="numeroContrato"
                :label="translate('table.contract_number')"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="transaction-list_text">
                        {{ formatText(scope.row.numeroContrato) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="150px"
                prop="empresaDestino"
                :label="translate('table.counterparty_requester')"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="transaction-list_text">
                        {{ getCounterpartyRequesterName(scope.row) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="150px"
                prop="armazemOrigem"
                :label="translate('table.origin')"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="transaction-list_text">
                        {{ formatText(scope.row.armazemOrigem) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="150px"
                prop="armazemDestino"
                :label="translate('table.destination')"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="transaction-list_text">
                        {{ formatText(scope.row.armazemDestino) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="135px"
                prop="volumeOrigemTonFormatado"
                :label="translate('table.outbound_volume')"
                label-class-name="transaction-list-table_label"
            />
            <el-table-column
                width="130px"
                prop="volumeDestinoTonFormatado"
                :label="translate('table.inbound_volume')"
                label-class-name="transaction-list-table_label"
            />
            <el-table-column
                width="90px"
                :label="translate('table.actions')"
                align="center"
                label-class-name="transaction-list-table_label"
            >
                <template v-slot:default="scope">
                    <el-dropdown
                        class="action-button"
                        trigger="click"
                        @click="scope"
                    >
                        <span class="el-dropdown-link">
                            <i class="mdi mdi-dots-vertical" />
                        </span>
                        <el-dropdown-menu v-slot="dropdown">
                            <el-dropdown-item
                                v-if="checkApprovalCredential() === true && checkIsPendingTransaction(scope.row)"
                                icon="el-icon-edit"
                                @click.native="openTransactionApproveModal(scope.row)"
                            >
                                {{ translate('messages.view.analise') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                icon="el-icon-map-location"
                                @click.native="openViewTerritoriesModal(scope.row)"
                            >
                                {{ translate('messages.view.view_territories') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="checkApprovalCredential() === true && checkIsInvoiceTransaction(scope.row)"
                                icon="el-icon-delete"
                                @click.native="openInvoiceCancelModal(scope.row)"
                            >
                                {{ translate('messages.view.cancel') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div class="transaction-list-table__pagination">
            <div class="total">
                <span
                    >{{ totalElements }}
                    {{
                        translate('messages.view.results')
                    }}</span
                >
                <div style="margin: 0 20px"></div>
                <span
                    >{{
                        translate('messages.view.views_by_page')
                    }}:</span
                >
                <el-pagination
                    @size-change="handleSizeChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="sizes"
                    :total="totalElements"
                />
            </div>
            <div class="prev_next">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="prev, pager, next, jumper"
                    :total="totalElements"
                />
            </div>
        </div>
        <transaction-approve-modal
            v-if="selectedTransaction"
            :show="showTransactionApproveModal"
            :transaction="selectedTransaction"
            @close="closeModal()"
            @confirm="handleApproveModalConfirm"
        />
        <view-territories-modal
            v-if="showViewTerritoriesModal"
            :show="showViewTerritoriesModal"
            :transaction="selectedTransaction"
            @close="closeModal()"
        />
        <transaction-cancel-modal
            v-if="selectedTransaction"
            :show="showInvoiceCancelModal"
            :transaction="selectedTransaction"
            @close="closeModal()"
            @confirm="getOperations"
        />
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import RastreabilidadeTransacaoArmazemService from '@/services/RastreabilidadeTransacaoArmazemService';
import TransactionApproveModal from '@/modules/warehouse/views/pages/viewWarehouse/components/transaction-approve-modal/index.vue';
import TransactionCancelModal from '@/modules/warehouse/views/pages/viewWarehouse/components/transaction-cancel-modal/index.vue';
import ViewTerritoriesModal from '@/modules/warehouse/views/components/ViewTerritoriesModal.vue';
import formatters from '@/utils/formatters';

export default {
    name: 'warehouseTransactionList',
    components: {
        TransactionApproveModal,
        ViewTerritoriesModal,
        TransactionCancelModal
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            page: 1,
            size: 10,
            totalElements: 0,
            operations: [],
            showTransactionApproveModal: false,
            showInvoiceCancelModal: false,
            selectedTransaction: null,
            showViewTerritoriesModal: false,
            filteredCompanies: []
        };
    },
    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters(['empresasSubEmpresasPorPais'])
    },
    async mounted() {
        if (this.empresasSubEmpresasPorPais.length === 0) {
            await this.fetchEmpresasSubEmpresasPorPais(this.usuarioLogado.paisGrupo ? this.usuarioLogado.paisGrupo : 'PY');
        }
        this.filteredCompanies = this.empresasSubEmpresasPorPais;
        this.getOperations();
    },
    watch: {
        filters: {
            handler(newVal) {
                this.getOperations();
            },
            deep: true
        }
    },
    methods: {
        ...mapActions(['fetchEmpresasSubEmpresasPorPais']),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        handleSizeChange(size) {
            this.page = 1;
            this.size = size;
            this.getOperations();
        },
        handleCurrentChange(page) {
            this.page = page;
            this.getOperations();
        },
        async getOperations() {
            if (this.filters) {
                await RastreabilidadeTransacaoArmazemService.getOperationsByWarehouseFilter(
                    {...this.filters},
                    (this.page - 1), this.size
                ).then(({ data }) => {
                    this.operations = data.itens;
                    this.totalElements = data.totalItens;
                });
            }
        },
        formatDateTimeToString(dateTimeFromApi) {
            return formatters.splitApiDateTimeForTable(dateTimeFromApi, this.$i18n.locale);
        },
        checkApprovalCredential() {
            return this.usuarioLogado.armazemRastreabilidadeAccess;
        },
        checkIsPendingTransaction(row) {
            let validTransactionType = false;
            switch (row.codigoTipoTransacao) {
                case 'EMPRESTIMO':
                    validTransactionType = this.usuarioLogado.idEmpresasFiltro.includes(row.empresaOrigem);
                    break;

                case 'TRANSFERENCIA_TITULARIDADE':
                    validTransactionType = this.usuarioLogado.idEmpresasFiltro.includes(row.empresaDestino);
                    break;
            }
            return row.codigoStatus === 'EM_TRANSITO' && validTransactionType;
        },
        checkIsInvoiceTransaction(row) {
            return row.codigoTipoTransacao === 'NOTA_FISCAL' && row.codigoStatus === 'APROVADA';
        },
        openTransactionApproveModal(row) {
            this.showTransactionApproveModal = true;
            this.selectedTransaction = row;
        },
        openViewTerritoriesModal(row) {
            this.showViewTerritoriesModal = true;
            this.selectedTransaction = row;
        },
        openInvoiceCancelModal(row) {
            this.showInvoiceCancelModal = true;
            this.selectedTransaction = row;
        },
        closeModal() {
            this.showTransactionApproveModal = false;
            this.showViewTerritoriesModal = false;
            this.showInvoiceCancelModal = false;
            this.selectedTransaction = null;
        },
        handleApproveModalConfirm() {
            this.getOperations();
            this.$emit('refresh-loan-totalizers');
        },
        formatText(text) {
            if (!text || text === '') {
                return '-';
            } else {
                return text;
            }
        },
        getCompanyName(companyId) {
            const company = this.filteredCompanies.find(company => company.id === companyId);
            return company ? company.name : '-';
        },
        getCounterpartyRequesterName(row) {
            switch (row.codigoTipoTransacao) {
                case 'EMPRESTIMO':
                case 'TRANSFERENCIA_TITULARIDADE':
                    return this.getCompanyName(this.getCounterpartyCompanyId(row));
                default:
                    return '-';
            }
        },
        getCounterpartyCompanyId(row) {
            const viewerIsCompanyOrigem = this.usuarioLogado.idEmpresasFiltro.includes(row.empresaOrigem);
            return viewerIsCompanyOrigem ? row.empresaDestino : row.empresaOrigem;
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep .transaction-list-table_label {
    word-break: keep-all !important;
}
.transaction-list_text {
    word-break: keep-all !important;
}
.table_second-row-label {
    color: #7C7C7C !important;
    font-size: 12px;
}
.transaction-list-card {
    margin-top: -8px;
    .el-table {
        .action-button {
            cursor: pointer;
        }
    }
    .transaction-list-table__pagination {
        display: grid;
        grid-template-columns: 2fr auto;
        margin: 20px 12px 0;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .total {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }

        .prev_next {
            display: flex;
            @media (max-width: 768px) {
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
}
.level1-label {
    font-size: 12px;
    color: #7c7c7c !important;
}
</style>
